import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchMealByIdArgs,
  FetchMealsArgs,
} from '../api/types/meals.types';

import { fetchMealById, fetchMeals } from '../api/meals.api';

export const mealsQueryKeys = createQueryKeys('meals', {
  fetchInfiniteMeals: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchMealsArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchMeals({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchMealById: ({
    id,
    locale,
    organizationId,
    userUnitSettings,
  }: FetchMealByIdArgs) => ({
    queryFn: () =>
      fetchMealById({ id, locale, organizationId, userUnitSettings }),
    queryKey: [id, organizationId, locale],
  }),
});
